import { useState } from "react";
import { faqItems } from "@/mocks/lustCaution";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 scroll-mt-20">
      <div className="px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-3xl mx-auto">
          <div className="text-center">
            <p className="text-primary-600 font-label text-sm tracking-widest uppercase">FAQ</p>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-snug">
              常见问题
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed">
              关于未删减版，最常被问到的几个问题，答案都在这里。
            </p>
          </div>

          <div className="mt-10 divide-y divide-background-200 border-y border-background-200">
            {faqItems.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer"
                  >
                    <span className="flex items-start gap-3">
                      <span className="font-heading text-primary-600 text-sm md:text-base mt-0.5">Q</span>
                      <span className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug">
                        {item.q}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 text-xl text-foreground-400 transition-transform ${
                        isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                  {isOpen && (
                    <p className="pb-5 pl-6 pr-8 text-sm md:text-base text-foreground-600 leading-relaxed">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}